import { Component, DestroyRef, Input, OnInit } from '@angular/core';
import { ScreenDTOEnhanced } from '../../../pages/network/device-details/device-details-screens/device-details-screens.component';
import { TableWrapperOptions } from '../../../services/global/global-interfaces';
import { API, TemplateGroupDTO } from '../../../services/api/api';
import { ErrorService } from '../../../services/error.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { finalize, take } from 'rxjs/operators';

@Component({
  selector: 'sb-comp-rendered-groups',
  templateUrl: './rendered-groups.component.html',
  styleUrls: ['./rendered-groups.component.scss'],
  standalone: false,
})
export class RenderedGroupsComponent implements OnInit {
  @Input({ required: true }) screen: ScreenDTOEnhanced;

  loading: boolean;
  options: TableWrapperOptions;
  lastRequest: number;

  groups: TemplateGroupDTO[];

  constructor(
    private api: API,
    private destroyRef: DestroyRef,
    private errorHandler: ErrorService
  ) {
    this.lastRequest = -1;
    this.loading = true;
    this.groups = [];
  }

  ngOnInit() {
    if (!this.screen) {
      throw new Error('No Screen Provided');
    }
    this.loading = true;
    this.api
      .ss_nm_Screen_retrieveTemplateGroupsByScreen(this.screen.id, null, null)
      .pipe(
        takeUntilDestroyed(this.destroyRef),
        take(1),
        finalize(() => {
          this.loading = false;
        })
      )
      .subscribe({
        next: groups => {
          this.groups = groups;
        },
        error: error => {
          this.errorHandler.errorHandler(error);
        },
      });
  }
}
